var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 246,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.791 241.998l6.141-4.3c5.864 4.341 14.075 4.679 20.38.264l5.045-3.532c5.673 7.256 16.1 8.877 23.733 3.532l36.904-25.84a17.408 17.408 0 002.422 4.988c5.524 7.89 16.399 9.807 24.288 4.283l55.319-38.735c7.89-5.524 9.807-16.398 4.283-24.288-5.525-7.89-16.399-9.807-24.289-4.283l-1.341.94a17.443 17.443 0 00-2.423-4.989c-5.524-7.89-16.398-9.807-24.288-4.283l-5.045 3.533c-5.673-7.256-16.1-8.877-23.733-3.533l-59.901 41.944a17.412 17.412 0 00-2.4-4.913c-5.524-7.89-16.399-9.808-24.288-4.283L24.94 213.274c-7.89 5.524-9.808 16.398-4.283 24.288 5.362 7.658 15.764 9.689 23.585 4.751 5.79 3.783 13.537 3.895 19.55-.315z",
    fill: "#EBF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "onboarding1_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 142,
    width: 229,
    height: 104
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.791 241.998l6.141-4.3c5.864 4.341 14.075 4.679 20.38.264l5.045-3.532c5.673 7.256 16.1 8.877 23.733 3.532l36.904-25.84a17.408 17.408 0 002.422 4.988c5.524 7.89 16.399 9.807 24.288 4.283l55.319-38.735c7.89-5.524 9.807-16.398 4.283-24.288-5.525-7.89-16.399-9.807-24.289-4.283l-1.341.94a17.443 17.443 0 00-2.423-4.989c-5.524-7.89-16.398-9.807-24.288-4.283l-5.045 3.533c-5.673-7.256-16.1-8.877-23.733-3.533l-59.901 41.944a17.412 17.412 0 00-2.4-4.913c-5.524-7.89-16.399-9.808-24.288-4.283L24.94 213.274c-7.89 5.524-9.808 16.398-4.283 24.288 5.362 7.658 15.764 9.689 23.585 4.751 5.79 3.783 13.537 3.895 19.55-.315z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.739 109.523c-6.159 0-11.151-5.004-11.151-11.176 0-6.172 4.992-11.176 11.15-11.176 6.16 0 11.152 5.004 11.152 11.176 0 6.172-4.993 11.176-11.151 11.176z",
    fill: "#FECFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.774 214.253a6.462 6.462 0 006.389-5.595l3.687-27.026a6.49 6.49 0 00.048-1.246l-1.472-25.78a6.46 6.46 0 00-6.815-6.09c-3.482.2-6.162 3.13-6.086 6.596.001.078.004.156.009.234L33.97 180.5l-3.602 26.406c-.483 3.541 1.99 6.803 5.523 7.287.297.04.592.06.883.06z",
    fill: "#50555A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.108 214.175c3.566 0 6.456-2.896 6.456-6.47v-28.818a6.42 6.42 0 00-.064-.907l-3.497-24.759c-.5-3.538-3.77-6-7.298-5.499-3.531.501-5.988 3.775-5.489 7.313l3.435 24.308v28.363c0 3.573 2.89 6.469 6.456 6.469z",
    fill: "#42464A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.779 159.576H32.776l-.276-4.826v-33.904c0-4.169 3.09-7.548 6.9-7.548h14.478c3.811 0 6.9 3.379 6.9 7.548v38.73z",
    fill: "#2C475F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.765 163.317a5.37 5.37 0 01-1.387-1.131L37.18 146.01a5.403 5.403 0 01-1.155-4.963l6.263-21.961a5.38 5.38 0 016.595-3.805c2.87.773 4.569 3.733 3.797 6.608l-5.513 19.17 12.29 14.005a5.399 5.399 0 01-.486 7.609 5.373 5.373 0 01-6.207.644z",
    fill: "#FECFAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.65 135.906l-10.357-2.807 3.996-14.013a5.38 5.38 0 016.594-3.805c2.87.772 4.57 3.733 3.797 6.608l-4.03 14.017z",
    fill: "#48647D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2 155.848h13.125v15.312a4.375 4.375 0 01-4.375 4.375h-4.375a4.375 4.375 0 01-4.375-4.375v-15.312zM222.325 155.848v15.312a4.375 4.375 0 01-4.375 4.375h-4.375a4.375 4.375 0 01-4.375-4.375v-15.312h13.125z",
    fill: "#444"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.937 153.904h83.739v-33.348a2.752 2.752 0 00-2.752-2.752l-1.269-33.918c-.093-2.484-2.023-4.5-4.504-4.662-6.524-.424-19.519-1.14-32.839-1.14-13.427 0-26.855.728-33.518 1.15-2.47.157-4.403 2.153-4.516 4.626l-1.385 30.198-.212 3.746a2.744 2.744 0 00-2.744 2.744v33.356z",
    fill: "#435C72"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.1 117.718l-1.188-38.596a474.997 474.997 0 00-31.6-1.038 496.64 496.64 0 00-32.478 1.064l-1.234 38.57h66.5z",
    fill: "url(#onboarding1_svg__paint0_linear_0_6951)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.76 113.525h2.573v-1.128c0-.783.524-1.462 1.3-1.574.941-.135 2.373-.265 4.221-.208 1.781.055 3.264.262 4.294.453.898.167 1.429 1.045 1.238 1.938l-.214 1.004c-.469 2.198-2.327 3.835-4.57 3.956-1.253.067-2.457.11-2.966.063-1.256-.115-2.065-.956-2.065-.956l-.94.358-.507 1.469s-.485-.564-1-.821c-.515-.256-1.2-.275-1.2-.275l-.164-4.279zM141.923 113.525h-2.609v-1.128c0-.783-.524-1.462-1.3-1.574-.941-.135-2.373-.265-4.221-.208a28.606 28.606 0 00-4.294.453c-.898.167-1.429 1.045-1.238 1.938l.214 1.004c.469 2.198 2.327 3.835 4.57 3.956 1.253.067 2.457.11 2.966.063 1.256-.115 2.065-.956 2.065-.956l.94.358.506 1.469s.486-.564 1.001-.821c.515-.256 1.2-.275 1.2-.275l.2-4.279z",
    fill: "#444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onboarding1_svg__filter0_i_0_6951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.937 153.904l1.123 10.619a2.8 2.8 0 002.785 2.506h76.411a2.1 2.1 0 002.085-1.853l1.335-11.272v-.305h-83.739v.305z",
    fill: "#3A5165"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.853 133.606c.02 0 .037.001.057.003.4.033 5.203.43 9.826.625 4.619.196 9.373.204 9.774.205l.058.001c.651.044 1.179.58 1.186 1.211l.025 2.247c.007.627-.503 1.117-1.147 1.112l-.085-.001a185 185 0 01-9.811-.156 182.404 182.404 0 01-9.846-.679c-.645-.05-1.166-.583-1.173-1.21l-.025-2.247c-.007-.631.51-1.123 1.161-1.111z",
    fill: "#CEE8FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.939 133.606a.544.544 0 00-.057.003c-.4.033-5.203.43-9.826.625-4.62.196-9.373.204-9.774.205l-.058.001c-.651.044-1.179.58-1.186 1.211l-.025 2.247c-.007.627.503 1.117 1.147 1.112l.085-.001c.458.007 4.627.063 9.811-.156a182.228 182.228 0 009.846-.679c.645-.05 1.166-.583 1.173-1.21l.025-2.247c.007-.631-.51-1.123-1.161-1.111z",
    fill: "#BEE1FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 156.348a3.125 3.125 0 01-3.125-3.125V68.848a3.125 3.125 0 016.25 0v84.375a3.125 3.125 0 01-3.125 3.125z",
    fill: "#95A5A5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 81.347c12.081 0 21.875-9.793 21.875-21.874 0-12.082-9.794-21.875-21.875-21.875S80.625 47.39 80.625 59.472c0 12.082 9.794 21.875 21.875 21.875z",
    fill: "#E8DBFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.375 140.723h6.25a6.25 6.25 0 016.25 6.25v40.625a9.375 9.375 0 01-3.75 7.5c-6.18 4.635-15 .225-15-7.5v-40.625a6.25 6.25 0 016.25-6.25z",
    fill: "#7F8C8D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.138 23.273h-2.198v2.197a2.196 2.196 0 11-4.394 0v-2.197h-2.197a2.196 2.196 0 01-2.198-2.198c0-1.214.983-2.197 2.198-2.197h2.197v-2.197a2.196 2.196 0 114.394 0v2.197h2.198a2.196 2.196 0 110 4.395z",
    fill: "#FECFAF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M199.986 36.456h-2.197v2.197a2.196 2.196 0 11-4.394 0v-2.197h-2.198A2.196 2.196 0 01189 34.26c0-1.215.983-2.197 2.197-2.197h2.198v-2.198a2.196 2.196 0 114.394 0v2.198h2.197a2.196 2.196 0 110 4.394z",
    fill: "#E0D7FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M267.895 138.497h-2.198v2.198a2.196 2.196 0 01-2.197 2.197 2.196 2.196 0 01-2.197-2.197v-2.198h-2.198a2.196 2.196 0 110-4.394h2.198v-2.198c0-1.214.982-2.197 2.197-2.197s2.197.983 2.197 2.197v2.198h2.198a2.196 2.196 0 110 4.394z",
    fill: "#FECFAF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.133 10.09h-2.344v2.196a2.196 2.196 0 01-2.197 2.198 2.196 2.196 0 01-2.197-2.198V10.09h-2.198A2.196 2.196 0 0147 7.892c0-1.215.983-2.197 2.197-2.197h2.197V3.497c0-1.214.983-2.197 2.198-2.197 1.214 0 2.197.983 2.197 2.197v2.198h2.344c1.214 0 2.197.982 2.197 2.197a2.196 2.196 0 01-2.197 2.197z",
    fill: "#E0D7FE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3 77.592a4.592 4.592 0 109.184 0 4.592 4.592 0 00-9.184 0zM252.316 94.892a4.592 4.592 0 109.184 0 4.592 4.592 0 00-9.184 0z",
    stroke: "#E0D7FE",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M252.316 14.484a4.592 4.592 0 109.184 0 4.592 4.592 0 00-9.184 0z",
    stroke: "#FECFAF",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding1_svg__paint0_linear_0_6951",
    x1: 147.6,
    y1: 78.084,
    x2: 147.6,
    y2: 117.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C8D7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onboarding1_svg__filter0_i_0_6951",
    x: 138.937,
    y: 153.599,
    width: 83.74,
    height: 16.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_0_6951"
  })))));
}
export default SvgOnboarding1;